import { QueryStatus } from '@tanstack/react-query'
import React from 'react'
import LoadingCard from './LoadingCard.tsx'
import { Card } from './Card.tsx'

interface Props {
  status: QueryStatus
  children: React.ReactNode
}

function PageLoaderLegacy(props: Props) {
  const { status, children } = props

  if (status === 'pending') {
    return <LoadingCard title="Loading..." />
  }

  if (status === 'error') {
    return <Card>Error</Card>
  }
  if (status === 'success') {
    return children
  }

  return <></>
}

export default PageLoaderLegacy
